/* eslint-disable react/require-default-props,react/default-props-match-prop-types,react/destructuring-assignment */

import _isFunction from 'lodash/isFunction';
import React from 'react';
import PropTypes from 'prop-types';
import { alertDialog } from '../../Modals/AlertDialog';
import { Button } from '../Button/Button';
import { executeAfterMinDelay } from '../../../utilities/utilities';

export class ActionPromiseButton extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    colour: PropTypes.string,
    shape: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    executeAfterMinDelay: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    label: 'Save',
    executeAfterMinDelay,
  };

  state = {
    isSaving: false,
  };

  componentWillMount() {
    this.setIsSaving = (isSaving) => {
      this.setState({ isSaving });
    };
  }

  componentWillUnmount() {
    this.setIsSaving = () => {};
  }

  onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const startTime = Date.now();
    this.setIsSaving(true);
    return this.props.onClick().then(
      (response) => {
        this.props.executeAfterMinDelay(
          () => {
            this.setIsSaving(false);
            if (_isFunction(this.props.onSuccess)) {
              this.props.onSuccess(response);
            }
          },
          startTime,
          300
        );
      },
      (error) => {
        this.setIsSaving(false);
        if (_isFunction(this.props.onError)) {
          this.props.onError(error);
        } else if (error && error.errorTitle && error.errorMessage) {
          alertDialog({
            title: error.errorTitle,
            message: error.errorMessage,
          });
        }
      }
    );
  };

  render() {
    const {
      icon,
      disabled,
      onClick,
      onSuccess,
      onError,
      executeAfterMinDelay: execAfterMinDelay,
      ...otherProps
    } = this.props;
    const { isSaving } = this.state;
    const iconProps = isSaving ? { spin: true } : {};

    return (
      <Button
        icon={isSaving ? 'spinner' : icon}
        disabled={isSaving || disabled}
        iconProps={iconProps}
        {...otherProps}
        onClick={this.onClick}
      />
    );
  }
}
